import { __extends } from "tslib";
import { ASObject } from '@awayfl/avm2';
var DigitCase = /** @class */ (function (_super) {
    __extends(DigitCase, _super);
    function DigitCase() {
        var _this = _super.call(this) || this;
        console.warn('[DigitCase] not implemented');
        return _this;
    }
    DigitCase.forceNativeConstructor = true;
    DigitCase.forceNativeMethods = true;
    // JS -> AS Bindings
    DigitCase.DEFAULT = 'default';
    DigitCase.LINING = 'lining';
    DigitCase.OLD_STYLE = 'oldStyle';
    return DigitCase;
}(ASObject));
export { DigitCase };
